export default "__VITE_ASSET__BqmqTjmL__"